import { EMPTY_ARRAY, IApplicationState, TListId } from '../../../types/types';
import { getPushNotificationSettingsByBoardId } from './getPushNotificationSettingsByBoardId';

export const getPushNotificationMoveToListIds = (
    state: IApplicationState,
    boardId: number
): TListId[] => {
    const notificationsSettings = getPushNotificationSettingsByBoardId(state, boardId);
    return notificationsSettings && notificationsSettings.moveToListIds || EMPTY_ARRAY;
};
